import { render, staticRenderFns } from "./UploadFromComputerForm.vue?vue&type=template&id=0a7b1926&"
import script from "./UploadFromComputerForm.vue?vue&type=script&lang=js&"
export * from "./UploadFromComputerForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadFromComputerForm.vue?vue&type=style&index=0&id=0a7b1926&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports